export default __webpack_public_path__ + "static/media/2012-ADA-DentalClaimForm-for-Website.6cea1608.pdf";